var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Caption, Label } from "../Text";
import { Div } from "../utils";
import { SvgHide } from "../Svgs/Hide";
import { SvgShow } from "../Svgs/Show";
export const HTMLInput = styled.input `
  outline: none;
  border: none;
  width: 100%;
  box-sizing: border-box;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  -moz-appearance: textfield;

  background: ${(p) => p.theme.colors.white};
  border: solid 1px ${(p) => p.theme.colors.black20};
  border-radius: 6px;
  padding: 10px 12px;

  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${(p) => p.theme.colors.black80};

  ::placeholder {
    font-family: Poppins;
    font-size: 12px;
    font-weight: normal;
    line-height: 17px;
    color: ${(p) => p.theme.colors.black40};
    ${(p) => p.isDisabled &&
    css `
        color: ${(p) => p.theme.colors.gray3};
      `};
  }
  :focus {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.24);
  }

  ${(p) => p.isDisabled &&
    css `
      cursor: not-allowed;
      pointer-events: none;
      color: ${(p) => p.theme.colors.black40};
      border: solid 1px ${(p) => p.theme.colors.gray3};
    `};

  ${(p) => p.hasError &&
    css `
      padding-right: 50px;
      border: solid 2px ${(p) => p.theme.colors.error};
    `};
  ${(p) => p.hasRightIcon &&
    css `
      padding-right: 42px;
    `};
  ${(p) => p.hasLeftIcon &&
    css `
      padding-left: 42px;
    `};
`;
const InputIcon = styled(Div) `
  position: absolute;
  top: 0;
  height: 100%;
  color: ${(p) => p.theme.colors.black60};
`;
const RightIcon = styled(InputIcon) `
  right: 14px;
`;
const LeftIcon = styled(InputIcon) `
  left: 14px;
`;
export const TextInput = (_a) => {
    var { label = "", leftIcon, rightIcon, placeholder = "", value = "", type = "text", isDisabled = false, hasError = false, helperText, onChange, onBlur, onFocus } = _a, props = __rest(_a, ["label", "leftIcon", "rightIcon", "placeholder", "value", "type", "isDisabled", "hasError", "helperText", "onChange", "onBlur", "onFocus"]);
    const { passwordVisibleIcon, isPasswordVisible } = usePasswordVisibleIcon(type);
    const _rightIcon = passwordVisibleIcon || rightIcon;
    return (React.createElement(Div, Object.assign({ w100: true }, props),
        label && React.createElement(Label, { isDisabled: isDisabled }, label),
        React.createElement(Div, { pRelative: true, mt: label ? 4 : 0 },
            React.createElement(LeftIcon, { centered: true }, leftIcon),
            React.createElement(HTMLInput, Object.assign({}, {
                hasRightIcon: _rightIcon,
                hasLeftIcon: leftIcon,
                placeholder,
                isDisabled,
                onFocus,
                hasError,
                value,
            }, { type: isPasswordVisible ? "text" : type, onChange: (e) => !isDisabled && onChange(e.target.value), onBlur: () => onBlur && onBlur() })),
            React.createElement(RightIcon, { centered: true }, _rightIcon)),
        helperText && (React.createElement(Caption, { hasError: hasError, mt: 4 }, helperText))));
};
const PIcon = styled(Div) `
  ${(props) => {
    const c = props.theme.css;
    return [c.alignCenter, c.clickable];
}};
`;
const usePasswordVisibleIcon = (type) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    if (type !== "password")
        return { passwordVisibleIcon: null, isPasswordVisible: null };
    const passwordVisibleIcon = isPasswordVisible ? (React.createElement(PIcon, { title: "Hide", mt: -2, onClick: () => setIsPasswordVisible(false) },
        React.createElement(SvgHide, null))) : (React.createElement(PIcon, { title: "Show", onClick: () => setIsPasswordVisible(true) },
        React.createElement(SvgShow, null)));
    return { isPasswordVisible, passwordVisibleIcon };
};
//# sourceMappingURL=index.js.map